<template>
  <div id="app">
    <app-header class="uk-margin-bottom" v-if="$route.name == 'Dashboard' || $route.name == 'Surveys'"></app-header>

    <div id="content-wrap">
      <router-view />
    </div>
    <loading-spinner v-if="!appInited"></loading-spinner>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import authContainer from "./lib/authContainer"

import Icons from "uikit/dist/js/uikit-icons";
import UIkit from "uikit";
import LoadingSpinner from "./components/LoadingSpinner.vue";
import { mapState } from "vuex";
UIkit.use(Icons);

export default {
  data: () => ({
    loading: true,
  }),
  components: {
    appFooter: Footer,
    appHeader: Header,
    LoadingSpinner
  },
  computed: {
    ...mapState({
      appInited: state => state.appInited
    })
  },
  watch: {
    $route(to) {
      document.title = to.meta.title || "Synergy Sourcing";
    }
  }, 
};
</script>

<style lang="less">
@import "./styles/app.less";
@import "./styles/modal.less";

#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  position: relative;
  min-height: 100vh;
  overflow: hidden;
}

#content-wrap {
  padding-bottom: 3.5rem;
  /* Footer height */
}

/* Transition fade animation */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.uk-notification-message {
  background-color: @color-whisper-gray;
}
</style>
